import { createSlice } from "@reduxjs/toolkit";

const data = {
    tiposDirecciones: [{ id: 0, descripcion: "" }],
    personaDirecciones: [{
        id: 0,
        idPersona: 0,
        numero: 0,
        idTipoDireccion: 0,
        tipoDireccion: "",
        idDireccion: 0,
        idUbigeo: 0,
        codigoUbigeo: "",
        resumenUbigeo: "",
        detalle: "",
        referencia: "",
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
}

export const personDirectionSlice = createSlice({
    name: "personDirection",
    initialState: {},
    reducers: {
        initPersonDirection: (state, action) => {
            const { sliceKey } = action.payload;
            if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
        },
        setTiposDirecciones: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].tiposDirecciones = data;
        },
        setPersonaDirecciones: (state, action) => {
            const { sliceKey, data } = action.payload;
            state[sliceKey].personaDirecciones = data;
        },
        setDatoPersonaDireccion: (state, action) => {
            var { sliceKey, numero, name, value } = action.payload;

            if (name.startsWith("id")) value = parseInt(value)

            const index = state[sliceKey].personaDirecciones.findIndex(item => item.numero === numero);
            state[sliceKey].personaDirecciones[index][name] = value;

        },
        addPersonaDireccion: (state, action) => {
            var sliceKey = action.payload;
            var maxNumero = state[sliceKey].personaDirecciones.length === 0 ? 0 : Math.max.apply(null, state[sliceKey].personaDirecciones.map((item) => { return item.numero; }))

            state[sliceKey].personaDirecciones.push(defaultPersonaDirecciones.map((item) => { return { ...item, numero: maxNumero + 1 } })[0]);
        },
        removePersonaDireccion: (state, action) => {
            const { sliceKey, numero } = action.payload;
            state[sliceKey].personaDirecciones = state[sliceKey].personaDirecciones.filter(item => item.numero !== numero)
        },
    },
});

export const { initPersonDirection, setTiposDirecciones, setPersonaDirecciones, setDatoPersonaDireccion
    , addPersonaDireccion, removePersonaDireccion } = personDirectionSlice.actions;
export const defaultPersonaDirecciones = [{
    id: 0,
    idPersona: 0,
    numero: 0,
    idTipoDireccion: 39,
    tipoDireccion: "Domicilio",
    idDireccion: 0,
    idUbigeo: 230101,
    codigoUbigeo: "230101",
    resumenUbigeo: "TACNA",
    detalle: "",
    referencia: "",
    fechaRegistro: null,
    usuarioRegistro: null,
    fechaModificacion: null,
    usuarioModificacion: null,
}]
export default personDirectionSlice.reducer;
